// auth-guard.service.ts

import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { AdminService } from '../Admin.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private adminService: AdminService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authService.loggedIn()) {

      const expectedUserTypes = route.data.expectedUserTypes as Array<string>;
      // when not specify role
      if (expectedUserTypes) {

        const actualUserTypeID: number = await this.adminService.getCurrentUserTypeAsync();

        switch (actualUserTypeID) {
          case 1:
            if (expectedUserTypes.indexOf('CAM') >= 0) { return true; }
            break;

          case 2:
            if (expectedUserTypes.indexOf('VAM') >= 0) { return true; }
            break;

          case 3:
            if (expectedUserTypes.indexOf('CAM') >= 0 || expectedUserTypes.indexOf('VAM') >= 0) { return true; }
            break;

          case 4:
            if (expectedUserTypes.indexOf('VAM') >= 0) { return true; }
            break;

          case 5:
            if (expectedUserTypes.indexOf('AD') >= 0) { return true; }
            break;
        }

        // 3 is both CAM/VAM user, 5 is AD
        // if (actualUserTypeID === 3 || actualUserTypeID === 5) {
        //   return true;
        // }
        // if (expectedUserType.indexOf('CAM') >= 0 && actualUserTypeID === 1) {
        //   return true;
        // }
        // if (expectedUserType.indexOf('VAM') >= 0 && actualUserTypeID === 2) {
        //   return true;
        // }

        this.router.navigate(['/pages/login'], { queryParams: { errorMsg: 'You are not authorized to access this page.' } });
      } else {
        return true;
      }

    } else {

      this.authService.redirectUrl = state.url;
      this.router.navigate(['/pages/login']);

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/auth-guard.service.ts